/* B.A.F. Bombs — theme interactions (vanilla). Prefix: .baf-* */
(function () {
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  };

  /* Scroll reveals (skip inside the theme editor so sections are visible) */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.baf-rv,.baf-rv-stagger');
    if (window.Shopify && Shopify.designMode) { els.forEach(function (el) { el.classList.add('baf-in'); }); return; }
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('baf-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('baf-in'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
    els.forEach(function (el) { if (!el.classList.contains('baf-in')) io.observe(el); });
  }

  /* Hero flavor switcher */
  function initHero(hero) {
    if (!hero || hero.dataset.bafInit) return; hero.dataset.bafInit = '1';
    var swatches = [].slice.call(hero.querySelectorAll('[data-flavor]'));
    if (!swatches.length) return;
    var dishName = hero.querySelector('[data-flavor-dish]');
    var dishImg = hero.querySelector('[data-flavor-img]');
    var flavName = hero.querySelector('[data-flavor-name]');
    var idx = Math.max(0, swatches.findIndex(function (s) { return s.classList.contains('baf-is-active'); }));
    var timer = null, interacted = false;
    function set(i) {
      idx = i; var f = swatches[i].dataset;
      hero.style.setProperty('--bg', f.bg); hero.style.setProperty('--acc', f.acc); if (f.broth) hero.style.setProperty('--broth', f.broth);
      hero.classList.toggle('baf-dark', f.dark === 'true');
      swatches.forEach(function (s, j) { s.classList.toggle('baf-is-active', j === i); s.setAttribute('aria-pressed', j === i); });
      if (dishName) dishName.textContent = f.dish || f.name;
      if (flavName) flavName.textContent = f.name;
      if (dishImg && f.img && dishImg.getAttribute('src') !== f.img) {
        dishImg.classList.add('baf-swap');
        setTimeout(function () { dishImg.src = f.img; dishImg.removeAttribute('srcset'); dishImg.alt = f.alt || ''; dishImg.classList.remove('baf-swap'); }, 220);
      }
    }
    function auto() { if (rm || interacted || (window.Shopify && Shopify.designMode)) return; timer = setInterval(function () { set((idx + 1) % swatches.length); }, 3800); }
    swatches.forEach(function (s, i) { s.addEventListener('click', function () { interacted = true; clearInterval(timer); set(i); }); });
    set(idx); auto();
  }

  /* Size / variant pickers */
  function updateCard(card, btn) {
    var price = btn.dataset.price, serves = btn.dataset.serves || '', variant = btn.dataset.variant, avail = btn.dataset.available !== 'false';
    card.querySelectorAll('[data-price]:not(button):not(option)').forEach(function (el) { el.textContent = price; });
    card.querySelectorAll('[data-serves]:not(button)').forEach(function (el) { el.textContent = serves; });
    var cmp = card.querySelector('[data-compare]:not(button)');
    if (cmp) { if (btn.dataset.compare) { cmp.textContent = btn.dataset.compare; cmp.hidden = false; } else { cmp.hidden = true; } }
    card.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = variant; });
    var add = card.querySelector('[data-add]');
    if (add) { add.disabled = !avail; add.textContent = avail ? (add.dataset.label || add.textContent) : (add.dataset.soldout || 'Sold out'); }
    var stock = card.querySelector('[data-stock]');
    if (stock) { var inv = parseInt(btn.dataset.inventory, 10), th = parseInt(stock.dataset.threshold, 10) || 10; if (!isNaN(inv) && inv > 0 && inv <= th) { stock.textContent = (stock.dataset.template || '').replace('[count]', inv); stock.hidden = false; } else { stock.hidden = true; } }
    document.querySelectorAll('[data-baf-sticky] [data-price]').forEach(function (el) { el.textContent = price; });
    if (btn.dataset.img) { var main = document.querySelector('[data-main-img]'); if (main) { main.src = btn.dataset.img; main.removeAttribute('srcset'); } }
    try { history.replaceState(null, '', location.pathname + '?variant=' + variant); } catch (e) {}
  }
  function initSizes(root) {
    (root || document).querySelectorAll('[data-sizes]').forEach(function (group) {
      if (group.dataset.bafInit) return; group.dataset.bafInit = '1';
      var btns = [].slice.call(group.querySelectorAll('button'));
      var card = group.closest('[data-product]');
      btns.forEach(function (b) { b.addEventListener('click', function () { btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); if (card) updateCard(card, b); }); });
    });
    (root || document).querySelectorAll('[data-variant-select]').forEach(function (sel) {
      if (sel.dataset.bafInit) return; sel.dataset.bafInit = '1';
      var card = sel.closest('[data-product]');
      sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; o.dataset.variant = o.value; if (card) updateCard(card, o); });
    });
  }

  /* Quantity */
  function initQty(root) {
    (root || document).querySelectorAll('.baf-qty').forEach(function (q) {
      if (q.dataset.bafInit) return; q.dataset.bafInit = '1';
      var inp = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { var v = parseInt(inp.value, 10) || 1; v = b.dataset.d === '-' ? Math.max(1, v - 1) : v + 1; inp.value = v; }); });
    });
  }

  /* Toast */
  var toast;
  function say(msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'baf-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.textContent = msg; toast.classList.add('baf-show'); clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('baf-show'); }, 2400);
  }

  /* AJAX add to cart → Motion cart drawer */
  function initAddForms(root) {
    (root || document).querySelectorAll('[data-baf-add-form], form.baf-pform').forEach(function (form) {
      if (form.dataset.bafInit) return; form.dataset.bafInit = '1';
      form.addEventListener('submit', function (e) {
        var idInput = form.querySelector('[name="id"]'); if (!idInput || !idInput.value) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]'); var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        var qtyEl = form.querySelector('[name="quantity"]');
        var body = { id: parseInt(idInput.value, 10), quantity: qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1 };
        var props = {}; form.querySelectorAll('[name^="properties["]').forEach(function (p) { var k = p.name.slice(11, -1); if (p.value) props[k] = p.value; });
        if (Object.keys(props).length) body.properties = props;
        var sp = form.querySelector('[name="selling_plan"]'); if (sp && sp.value) body.selling_plan = sp.value;
        fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { say(res.j.description || res.j.message || 'Could not add to cart'); return; }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.j, addToCartBtn: btn }, bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: body.id, qty: body.quantity } }));
            if (!(window.theme && theme.settings && theme.settings.cartType === 'drawer')) {
              say((btn && btn.dataset.name ? btn.dataset.name : res.j.product_title) + ' added to cart');
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', c.item_count > 0); }); });
            }
          })
          .catch(function () { form.removeAttribute('data-baf-init'); form.submit(); })
          .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
      });
    });
  }

  /* Gallery thumbs */
  function initGallery(root) {
    (root || document).querySelectorAll('.baf-gallery').forEach(function (g) {
      if (g.dataset.bafInit) return; g.dataset.bafInit = '1';
      var main = g.querySelector('[data-main-img]'); if (!main) return;
      g.querySelectorAll('.baf-thumbs img').forEach(function (t) {
        var pick = function () { main.src = t.dataset.full || t.src; main.removeAttribute('srcset'); main.alt = t.alt; g.querySelectorAll('.baf-thumbs img').forEach(function (x) { x.classList.toggle('baf-is-active', x === t); }); };
        t.addEventListener('click', pick); t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    });
  }

  /* Sticky buy bar */
  function initSticky() {
    var bar = document.querySelector('[data-baf-sticky]'), buy = document.querySelector('.baf-buy');
    if (!bar || !buy || bar.dataset.bafInit) return; bar.dataset.bafInit = '1';
    var o = new IntersectionObserver(function (es) { es.forEach(function (e) { bar.classList.toggle('baf-show', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, { threshold: 0 });
    o.observe(buy);
    var b = bar.querySelector('[data-sticky-add]'); if (b) b.addEventListener('click', function () { var add = buy.querySelector('[data-add]'); if (add && !add.disabled) add.click(); else buy.scrollIntoView({ behavior: 'smooth' }); });
  }

  /* Homepage sticky shop bar (mobile) */
  function initHomeSticky() {
    var bar = document.querySelector('[data-baf-home-sticky]'), hero = document.querySelector('[data-baf-hero]');
    if (!bar || !hero || bar.dataset.bafInit) return; bar.dataset.bafInit = '1';
    var anchor = bar.dataset.shopAnchor || '#shop'; var shop = anchor.charAt(0) === '#' ? document.querySelector(anchor) : null;
    var past = false, shopVis = false; var upd = function () { bar.classList.toggle('baf-show', past && !shopVis); };
    new IntersectionObserver(function (es) { es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }); }, { threshold: 0 }).observe(hero);
    if (shop) new IntersectionObserver(function (es) { es.forEach(function (e) { shopVis = e.isIntersecting; upd(); }); }, { threshold: 0.15 }).observe(shop);
  }

  function initAll(root) { initReveals(root); document.querySelectorAll('[data-baf-hero]').forEach(initHero); initSizes(root); initQty(root); initAddForms(root); initGallery(root); initSticky(); initHomeSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { var el = e.target; el.querySelectorAll('[data-baf-init]').forEach(function (x) { x.removeAttribute('data-baf-init'); }); initAll(el); el.querySelectorAll('.baf-rv,.baf-rv-stagger').forEach(function (x) { x.classList.add('baf-in'); }); });
  document.addEventListener('shopify:block:select', function (e) { var sw = e.target.closest && e.target.closest('[data-flavor]'); if (sw) sw.click(); });
})();
